export default __webpack_public_path__ + "static/media/biking.97e5618e.jpg";